/**
 * nordura-scroll-reveal.js
 * Adds `.is-visible` to any [data-n-reveal] element once it enters the
 * viewport (see the fade/slide-up transition in nordura-base.css). One
 * shared observer for the whole page instead of per-section scroll
 * listeners.
 */
(function () {
  'use strict';

  function init() {
    var targets = document.querySelectorAll('[data-n-reveal]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0.1 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
